import { 
    Component, 
    OnChanges,
    Input,
    Output,
    EventEmitter
} from "@angular/core";
import { Subject } from "rxjs";

@Component({
    selector: "zip-code-component",
    templateUrl: "./zip-code-component.html",
    styleUrls: ["./zip-code-component.scss"]
})
export class ZipCodeComponent implements OnChanges {
    @Input("zipCode") zip: string;
    originalZip: string;
    @Input() visibleEvent: Subject<string>;
    @Output() newZipEvent: EventEmitter<string> = new EventEmitter<string>();
    edit: boolean = false;

    ngOnChanges() {
        this.originalZip = this.zip.toString().slice(0)
    }

    toggleEdit() {
        this.edit = !this.edit;
    }

    cancel() {
        this.zip = this.originalZip.toString().slice(0)
        this.toggleEdit();
    }

    save() {
        const zip = this.zip.trim();
        const regex = new RegExp(/^(\d{5}|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/);
        if (regex.test(zip)) {
            this.toggleEdit();
            this.newZipEvent.next(zip);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/product-category/components/eco-rebates/zip-code-component/zip-code-component.ts